import React from "react";
import { Switch, BrowserRouter as Router, BrowserRouterProps, Redirect } from "react-router-dom";

import { IRouteProps, IRouterProps } from "./types";
import { Route } from "./route";

export const RootRouter: React.FC<IRouterProps & BrowserRouterProps> = ({ routes, ...rest }: IRouterProps & BrowserRouterProps) => (
    <Router basename="/" {...rest}>  {/* added basename */}
        <Switch>
            {routes.map((props: IRouteProps, i: number) => <Route key={i} {...props} />)}
        </Switch>
    </Router>
);

export const ChildRouter: React.FC<IRouterProps> = ({ routes }: IRouterProps) => (
    <Switch>
        {routes.map((props: IRouteProps, i: number) => <Route key={i} {...props} />)}
    </Switch>
);

export { Redirect };
